// ---------------------------------------------------------------------------
// Survive on BCH — Hustle Mode tuning constants (SIMULATED)
//
// The customer queue and per-round network conditions are generated fresh each
// run (see generate.ts). This file holds the fixed economic tuning knobs —
// fees, chargeback odds, starting reputation — that every run shares.
//
// All values are invented for gameplay.
// ---------------------------------------------------------------------------

import { RUN_LENGTH } from "./generate";

/** Number of customers served in a run. */
export const TOTAL_ROUNDS = RUN_LENGTH;

/** Merchant reputation starts here (0–100). */
export const STARTING_REPUTATION = 70;

/** Flat, near-zero simulated BCH fee for accepting a sale. */
export const BCH_ACCEPT_FEE_USD = 0.003;

/** Tiny simulated Lightning fee when it works. */
export const LIGHTNING_ACCEPT_FEE_USD = 0.004;

/** Card processing fee as a fraction of the sale (plus a small flat fee). */
export const CARD_FEE_RATE = 0.03;
export const CARD_FEE_FLAT_USD = 0.3;

/**
 * Simulated chargeback probabilities for card sales. A completed card sale can
 * be reversed weeks later, costing the merchant the whole amount. BCH and
 * on-chain BTC are final — no chargebacks possible.
 */
export const CARD_CHARGEBACK_ODDS = 0.12;
export const CARD_CHARGEBACK_ODDS_RISKY = 0.35;

/**
 * Simulated odds that a Lightning payment fails to route / the customer's
 * wallet can't complete it (only applies to lightning-capable customers).
 */
export const LIGHTNING_FAIL_ODDS = 0.15;
